import { useEffect, useState, useRef } from "react";
import {
  faHeart
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemes } from "./context/MemesContext";
import useOnScreen from "../../shared/hooks/useOnScreen";
import { Link } from "react-router-dom";

const MemesSelect = (props: any) => {

  const { user } = props;
  const { photos, getPhotos } = useMemes();
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [loadCompleted, setLoadCompleted] = useState(false)
  
  useEffect(() => getPhotos(page), []);
  
  const bottomRef = useRef<HTMLInputElement | null>(null);;
  const isVisible = useOnScreen(bottomRef);

  // once BottomRef is visible update page count
  useEffect(() => {
    if (bottomRef.current && isVisible) {
      console.log(`${page}`, 'load from isVisible')
      setPage(page + 1)
    }
  }, [isVisible]);

  // this one is needed because of a tricky sitch where
  // the newly loaded items do not push the bottomRef far enough
  // so it becomes false and then true again but it just stays true..
  // this one checks if bottomReg is visible upon the fetching of new items
  // and if so, it adds another page for loading
  useEffect(() => {
    // caching the count before we update it so we compare it
    // with the current number of records
    const old_count = count;

    setCount(photos.length)

    // if the old_count is the same is the number of photos then no new
    // items have been fetched and ergo all items are already loaded
    if (old_count == photos.length) {
      setLoadCompleted(true)
    }

    // checks if the bottomRef is visible AND if new records were loaded
    // with the previous page (otherwise it will just be adding new page indefinitely)
    if (isVisible && old_count != photos.length) {
      setPage(page + 1)
    }
  }, [photos]);

 // on page count update fetch more memes
  useEffect(() => {
    getPhotos(page)
  }, [page]);


  console.log(user, 'user')
  return (
    <>
      <div className="grid-container">
      	<div className="grid-x">
          {photos.map((photo) => (
            <Photo src={photo.url} key={photo.id} photo={photo} />
          ))}
          <div className="cell">
            <div style={{textAlign: 'center', padding: '20px'}} ref={bottomRef}>
              <div className="clock-loader" style={{margin: 'auto'}}></div>
            </div>
          </div>
      	</div>
      </div>
    </>
  );
}

const Photo = (props: any) => {
  const { photo } = props;
  return(
    <div className="cell medium-3 small-6">
      <div className="floating-gallery--item" style={{backgroundImage: `url(${photo.url}), url(${photo.thumb_url})`}}>
        <Link to={`/new/${photo.kitten_identifier}/${photo.id}`} >+</Link>
      </div>
    </div>
  )
}

export default MemesSelect;